SWR.Social.prototype._getInstagramParams = function _getInstagramParams() {
  var self = this;
  var data = {};

  // Instagram
  data.endpoint = 'https://graph.facebook.com/v13.0/instagram_oembed';
  data.params = {
    'url': -1 !== self.url.indexOf('?') ? self.url.substring(0, self.url.indexOf('?')) : self.url,
    'access_token': self.fbAppId + '|' + self.fbAccessToken,
    'hidecaption': false,
    'omitscript': true
  };
  data.dataType = 'json';

  return data;
};

//Nachladen von Instagram-SDK:
SWR.Social.prototype._loadInstagramSDK = function _loadInstagramSDK() {
  // Load the SDK Asynchronously
  SWR.Util.loadScript('instagram', '//www.instagram.com/embed.js');
  try {
    instgrm.Embeds.process()
  } catch (e) {
    (console.error || console.log).call(console, e.stack || e)
  }
};
